// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_ng-select_ng-select_fesm2020_ng-select-ng-select_mjs-src_assets_iso_json":"dd83630d2cca76b0","src_app_hub_hub_module_ts":"4422551eaa682c2b","src_app_pages_pages_module_ts":"b585786c6a7c82d3","src_app_pages_admin_admin_module_ts":"fc7f966f471323b3"}[chunkId] + ".js";
};